import { IconButton } from '../../../lib/button'
import { FaEdit } from 'react-icons/fa'

export const Cols = (onRowClickUpdate) => {
  return [
    {
      name: 'ID',
      selector: 'beslenmeCategory_id',
      sortable: true,
      width: '80px',
      cell: row => <div style={{ fontSize: 14, fontWeight: 'bold' }}>{row.beslenmeCategory_id}</div>
    },

    {
      name: 'Kategori Adı',
      selector: 'beslenmeCategory_text',
      sortable: true,
      cell: row => <div style={{ fontSize: 14 }}>{row.beslenmeCategory_text}</div>
    },

    {
      name: '',
      selector: 'update',
      sortable: false,
      width: '90px',
      cell: row => (
        <IconButton
          icon={<FaEdit size={30} />}
          onClick={() => onRowClickUpdate(row.beslenmeCategory_id)}
        />
      )
    }
  ]
}
